import React from 'react';

import { AuthProvider } from './auth';
import { FileProvider } from './files';
import { LoadingProvider } from './loading';
import { NavigationProvider } from './Navigation';
import { SubmitModalProvider } from './SubmitModal';

const AppProvider: React.FC = ({ children }) => (
  <NavigationProvider>
    <SubmitModalProvider>
      <LoadingProvider>
        <FileProvider>
          <AuthProvider>{children}</AuthProvider>
        </FileProvider>
      </LoadingProvider>
    </SubmitModalProvider>
  </NavigationProvider>
);

export default AppProvider;
